import { createStore, combineReducers } from 'redux'
import resultInfoReducer from './reducers/resultInfo'

const rootReducer = combineReducers({resultInfo: resultInfoReducer})

export const store = createStore(rootReducer)
